import React from 'react';
import FontAwesome from 'react-fontawesome';

const SocialMeidaIcon = props => {
  // return <div className="social-media-icon"><a href="https://{props.platform}/{props.value}">icon</a></div>
  const url = 'https://' + props.platform + '/' + props.value;
  return (
    <div className="pl-1 pr-1 mb-2">
      <a href={url} target="_blank">
        <FontAwesome
          name={props.icon}
          size="lg"
          style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
        />
      </a>
    </div>
  );
};

export default SocialMeidaIcon;
